import React, {useState} from "react";
import {Modal} from "react-bootstrap";
import OtpInput from "react-otp-input";
import {useStores} from "../stores/Context";
import logo_seizo_s from "../images/svg/logo_seizo_s.svg";
import logo_seizo_nom from "../images/svg/logo_seizo_nom.svg";

import {useHistory, useLocation, Link} from 'react-router-dom';

const Login = (props) => {
    const history = useHistory();
    const location = useLocation();
    const {ent, setToken} = props;

    const {loginStore} = useStores();
    const [mailInput, setMailInput] = useState('');
    const [animation, setAnimation] = useState(false);
    const [message, setMessage] = useState({});
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');

    console.log('ent', ent);

    const handleOptApi = async (_ent, email) => {
        return await loginStore.getOtpMail(email);
    }

    const handleValidForm = async () => {
        // Vérifie si mailInput est vide
        if (!mailInput) {
            setMessage({
                error: true,
                message: "L'adresse e-mail ne peut pas être vide."
            });
            return;
        }

        // Vérifie si mailInput est un email valide
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(mailInput)) {
            setMessage({
                error: true,
                message: "Veuillez entrer une adresse e-mail valide."
            });
            return;
        }

        setAnimation(true);

        try {
            const result = await handleOptApi(ent, mailInput);

            if (result.status) {
                setOtpSent(true);
                setMessage({
                    error: false,
                    message: result.message
                });
            } else {
                setMessage({
                    error: true,
                    message: result.message
                });
            }
        } catch (error) {
            setMessage({
                error: true,
                message: "La demande de code n'a pas pu aboutir. Vérifiez votre connexion puis réessayez."
            });
        } finally {
            setAnimation(false);
        }
    }

    const handleValidOtp = async () => {
        setAnimation(true);

        const result = await loginStore.checkOtpMail(mailInput, otp);

        if (!result) {
            setMessage({
                error: true,
                message: "Connexion réussie mais aucun espace associé à ce compte. Contactez votre administrateur."
            });
            setAnimation(false);
            return;
        }

        if (!result.error) {
            setToken(result.token);
            setOtpSent(false);
            setAnimation(false);

            // Conserver la destination demandée avant connexion, notamment le
            // back-office Mon Compte depuis la landing. Les autres parcours
            // gardent la redirection métier renvoyée par l’API.
            const requestedDestination = location.pathname === '/mon-compte'
                ? '/mon-compte'
                : result.redirect;

            if (requestedDestination) {
                history.push(requestedDestination);
            }
        } else {
            setMessage({
                error: true,
                message: result.message
            });
            setAnimation(false);
        }
    };

    return (
        <Modal
            {...props}
            show={true}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered={true}
            backdrop="static"
            keyboard={false}
            dialogClassName={`w-50`}
            contentClassName={``}
            className={`modal-background`}
        >
            <Modal.Body className={"pb-5"}>
                <div
                    className={'mt-20 mb-20 w-full flex inline-flex justify-center items-center text-center mx-auto'}>
                    <img src={logo_seizo_s} alt="Logo SEIZO" className={"h-16 w-16 align-text-bottom"}/>
                    <img src={logo_seizo_nom} alt="Logo SEIZO nom" className={"h-14"}/>
                </div>
                <h1 className={'title__connexion'}>Connexion</h1>
                <div className={"border-none " + (animation ? " opacity-20" : "")}>
                    {/*<label htmlFor="small-input"*/}
                    {/*       className={"ml-20 block mb-2 text-xl font-medium text-gray-900 dark:text-white" + (animation ? " opacity-20" : "")}>*/}
                    {/*    Mot de passe*/}
                    {/*</label>*/}
                    {/*<input*/}
                    {/*    style={{fontSize: "2em"}}*/}
                    {/*    value={mdpInput}*/}
                    {/*    onChange={(e) => setMdpInput(e.target.value)}*/}
                    {/*    type="password"*/}
                    {/*    id="small-input"*/}
                    {/*    disabled={animation}*/}
                    {/*    className="block w-75 py-0 pl-2 mx-auto text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"*/}
                    {/*/>*/}
                    {/*<label htmlFor="small-input"*/}
                    {/*       className={"ml-20 block mb-2 text-xl font-medium text-gray-900 dark:text-white" + (animation ? " opacity-20" : "")}>*/}
                    {/*    Email*/}
                    {/*</label>*/}
                    {!otpSent ? (
                        <input
                            placeholder={'Adresse mail'}
                            // style={{fontSize: "2em"}}
                            value={mailInput}
                            onChange={(e) => setMailInput(e.target.value)}
                            type="email"
                            id="small-input"
                            disabled={animation}
                            className="block w-75 mx-auto"
                            style={{
                                borderRadius: '3px',
                                border: '1px solid var(--icon-medium, #DBE3E7)',
                                background: 'var(--white, #FFF)'
                            }}
                        />
                    ) : (
                        <OtpInput
                            className={'block mx-auto'}
                            containerStyle={{
                                margin: '0 auto',
                                maxWidth: '100%',
                                padding: '0 1rem',
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'nowrap',
                            }}
                            inputStyle={{
                                border: '2px solid rgba(0, 0, 0, 0.175)',
                                borderRadius: '0.5rem',
                                fontSize: '1.75rem',
                                width: '1.4em',
                                height: '1.4em',
                            }}
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderSeparator={<span className={'mx-1'}> - </span>}
                            renderInput={(props) => <input {...props} />}
                        />
                    )}
                    {message ? (
                        <div className={`text-center ${message.error ? 'text-red-500' : 'text-green-500'}`}>
                            {message.message}
                        </div>
                    ) : null}
                    {!otpSent ? (
                        <button
                            style={{
                                display: "flex",
                                width: "28.75rem",
                                padding: "0.75rem 1.875rem",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "0.625rem",
                                borderRadius: "0.125rem 1.25rem 1.25rem 1.25rem",
                                background: "#002335",
                                color: "#fff",
                                fontFamily: '"Sofia Pro", "Nunito", sans-serif',
                                fontSize: "2rem",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "130%",
                            }}
                            className={'block mt-4 w-75 pl-2 mx-auto'}
                            onClick={() => handleValidForm()}
                            disabled={animation}
                        >
                            Envoyer
                        </button>
                    ) : (
                        <button
                            style={{
                                display: "flex",
                                width: "28.75rem",
                                padding: "0.75rem 1.875rem",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "0.625rem",
                                borderRadius: "0.125rem 1.25rem 1.25rem 1.25rem",
                                background: "#002335",
                                color: "#fff",
                                fontFamily: '"Sofia Pro", "Nunito", sans-serif',
                                fontSize: "2rem",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "130%",
                            }}
                            className={'block mt-4 w-75 pl-2 mx-auto'}
                            onClick={() => handleValidOtp()}
                            disabled={animation}
                        >
                            Verifier le code
                        </button>
                    )}
                </div>
                {
                    animation ? (
                        <>
                            <div role="status"
                                 className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                                <svg aria-hidden="true"
                                     className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                                     viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"/>
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"/>
                                </svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                        </>
                    ) : (<></>)
                }

                {!otpSent && (
                    <div style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '1rem', color: '#555' }}>
                        Pas encore de compte ?{' '}
                        <Link
                            to="/pricing"
                            style={{
                                color: '#66BE63',
                                fontWeight: 600,
                                textDecoration: 'underline',
                            }}
                        >
                            Créer un compte
                        </Link>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default Login;
